import { Component, ElementRef, ChangeDetectorRef, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ILoadingOptions } from '../../models';
import { LoadingService } from '../../services';

@Component({
  selector: 'lib-loading',
  styleUrls: ['loading.component.scss'],
  templateUrl: 'loading.component.html',
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  private readonly loadingScreenService = inject(LoadingService);
  private readonly _elmRef = inject(ElementRef);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);

  loadingSubscription!: Subscription;
  loadingOptions!: ILoadingOptions;

  ngAfterViewInit(): void {
    this._elmRef.nativeElement.style.display = 'none';
    this.loadingSubscription = this.loadingScreenService.loading$.pipe().subscribe((loadingOptions: ILoadingOptions) => {
      this.loadingOptions = loadingOptions;
      this._elmRef.nativeElement.style.display = loadingOptions.loading ? 'block' : 'none';
      this._changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }
}
